<template>
  <div>
    <div class="main-div">
      <h2
        style="
          text-align: center;
          font-size: 30px;
          padding: 20px;
          border-bottom: 1px solid #eee;
          margin: 0 20px 20px 20px;
          color: #4b4b4b;
        "
      >
        {{ abp.userInfo.memberLevelModel.name }}
      </h2>
      <div
        style="
          border: 1px solid #f77b04;
          width: 150px;
          text-align: center;
          margin: 0 auto;
          padding: 20px 10px;
        "
      >
        <img src="../../assets/images/earnestmoney.png" />
        <div style="margin: 10px; color: #4b4b4b; font-size: 20px; font-weight: bold">
          ￥{{ earnestMoney }}元
        </div>
        <div>保证金</div>
      </div>
      <div style="border-bottom: 1px solid #eee; margin: 20px; height: 1px"></div>
      
      <van-form @submit="earnestreturn">
        <div style="margin: 16px">
          <p style="font-size: 16px;margin-bottom:20px;color:rgb(253, 209, 8)" v-if="lastrecord.id > 0">
            退保申请中,请等待公司审核........
          </p>

          <van-button
            :color="$abctheme.basecolor"
            round
            block
            type="info"
            native-type="submit"
            style="margin-bottom:20px"
            >取消</van-button>
            <van-button
            :color="$abctheme.basecolor"
            round
            block
            type="info"
            @click="logout"
            >退出登录</van-button>
        </div>
      </van-form>
    </div>
    <van-dialog
      v-model="showreturn"
      title="取消退保"
      show-cancel-button
      @confirm="onSubmit"
    >
      <p style="margin: 10px; font-size: 14px">
        您确定要取消退保吗?
      </p>
      
    </van-dialog>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      earnestMoney: 0,
      wxopenid: "",
      arrow: false,
      showreturn: false,
      showPicker: false,
      columns: [
        "缺乏资金",
        "没有空闲时间",
        "做其他产品了",
        "不喜欢公司代理政策",
        "不喜欢公司管理模式",
        "其他",
      ],
      reason: "",
      suggestion: "",
      lastrecord: {}, //最后一次申请记录
    };
  },
  methods: {
    earnestreturn(){
    if (!this.abp.userInfo.wxPramOpenId) {
          this.$dialog.confirm({
            title:'未绑定微信,无法申请提现',
            message:'点击确定前往微信绑定!'
          })
          .then(()=>{
            this.$router.push({
              name:'set'
            })
          })
          return;
        }
        this.showreturn = true
    },
    onSubmit() {
       
      this.ajax
        .post(
          "/api/services/app/PhoneUser/CancelReturnEarnestmoney")
        .then((x) => {
          this.$toast.success("取消成功");
          location.reload();
           
        });
    },
    logout() {
      this.abp.auth.clearToken();
      location.reload();
    },
    onConfirm(val) {
      this.reason = val;
      this.showPicker = false;
    },
  },
  created() {
    this.earnestMoney = this.abp.userInfo.earnestMoney.toFixed(2);
    this.ajax
      .post("/api/services/app/PhoneUser/QueryCheckInfo")
      .then((x) => {
        this.lastrecord = x.result;

      });
  },
};
</script>

<style lang="scss" scoped>
.main-div {
  background: #fff;
  color: #b1b1b1;
  margin-top: 0;
  padding-bottom: 20px;
}
.mian {
  position: relative;
  background-color: rgb(179, 197, 135);
  border-radius: 4px;
  box-shadow: 2px 2px 4px #bbb;
  text-align: center;
  padding: 50px 0;
  font-size: 25px;
  margin: 80px 10px 80px 10px;
}

.mian-yy {
  font-size: 100px;
}

.mian-tit {
  font-size: 28px;
}

.van-form {
  margin-left: 10px;
  margin-right: 10px;
}

.van-cell {
  border-radius: 3px;
}
</style>
